import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "clip-path": "url(#a)"
    }, [
      _createElementVNode("path", { d: "M7.57 19.42c-1.65 0-3.13-.98-3.76-2.5l-.53-1.26 1.52-.64.53 1.26c.38.91 1.26 1.49 2.24 1.49.32 0 .64-.06.93-.19a2.446 2.446 0 0 0 1.31-3.18l-.53-1.26 1.52-.64.53 1.26c.87 2.07-.12 4.47-2.19 5.33-.5.21-1.03.32-1.57.32zM4.82 10.9l1.52-.64 2.31 5.52-1.52.64zm-2.68 2.01c-.42-1-.42-2.11 0-3.12a4 4 0 0 1 2.2-2.21 4.056 4.056 0 0 1 5.33 2.18l.53 1.26-1.52.64-.53-1.26a2.42 2.42 0 0 0-3.17-1.3 2.445 2.445 0 0 0-1.31 3.18l.53 1.26-1.52.64-.53-1.26zM26.53 10.69 25.2 9.68l1.01-1.33a4.173 4.173 0 0 0-.8-5.84 4.173 4.173 0 0 0-5.84.8l-1.01 1.33-1.33-1.01 1.01-1.33a5.825 5.825 0 0 1 8.17-1.12 5.825 5.825 0 0 1 1.12 8.17l-1.01 1.33zm-2.01 2.65-1.01 1.33a5.825 5.825 0 0 1-8.17 1.12 5.825 5.825 0 0 1-1.12-8.17l1.01-1.33 1.33 1.01-1.01 1.33a4.173 4.173 0 0 0 .8 5.84 4.173 4.173 0 0 0 5.84-.8l1.01-1.33 1.33 1.01zm-1.79-8.67 1.33 1.01-5.04 6.64-1.33-1.01z" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h30v20H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }